import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Heading, Icon } from '@scentregroup/ui'
import { occurrencesType } from '../../../types'
import ResponsiveImage from '../../responsive-image'
import IconRow from '../../icon-row'
import Occurrences from '../../occurrences'
import AutoPotentialLink from '../../auto-potential-link'
import { trackingTypes, trackingActions } from '../../../constants'
import Trackable from '../../trackable'
import { MAP_SLUGS_TO_ICONS } from './constants'
import style from './index.scss'

const getSlug = link => (link ? link.split('/').pop() : '')

const SpotlightCard = ({
  angleOrigin,
  color,
  desktopImageUrl,
  mobileImageUrl,
  link,
  url,
  title,
  location,
  occurrences,
  lazyLoad,
  alternateDesign,
  onClick,
  analyticsMetadata,
}) => {
  const iconForEntry = MAP_SLUGS_TO_ICONS[getSlug(link)]
  return (
    <Trackable
      {...analyticsMetadata}
      trackingAction={trackingActions.viewPromotion}
      type={trackingTypes.promotion}
    >
      <AutoPotentialLink
        link={url || link}
        className={
          alternateDesign ? style.SpotlightCardAlternative : style.SpotlightCard
        }
        onClick={onClick}
      >
        {iconForEntry ? (
          <div
            className={style[`withService${color}`]}
            data-test-id="spotlight-icon"
          >
            <Icon size="large" type={iconForEntry} />
          </div>
        ) : (
          <ResponsiveImage
            lazyLoad={lazyLoad}
            angleOrigin={angleOrigin}
            className={alternateDesign ? style.imageAlternative : style.image}
            desktopImageUrl={desktopImageUrl}
            mobileImageUrl={mobileImageUrl}
            mobileRatio="square"
            desktopRatio="standard"
            numberOfItems={3}
            bgSize="cover"
            alt={title}
            dataTestId="spotlight-image"
          />
        )}
        <div
          className={classNames({
            [style.card]: !alternateDesign,
            [style.cardAlternative]: alternateDesign,
            [style.hasBorder]: alternateDesign && color === 'White',
          })}
          data-test-id="spotlight-detail"
        >
          <Heading
            type="extrasmall"
            className={iconForEntry ? style.serviceTitle : style.title}
          >
            {title}
          </Heading>
          {location && <IconRow text={location} icon="location-drop-pin" />}
          {occurrences && <Occurrences occurrences={occurrences} />}
        </div>
      </AutoPotentialLink>
    </Trackable>
  )
}

SpotlightCard.propTypes = {
  location: PropTypes.string,
  color: PropTypes.string,
  occurrences: occurrencesType,
  angleOrigin: PropTypes.oneOf([
    'bottom-left',
    'top-left',
    'top-right',
    'bottom-right',
  ]),
  link: PropTypes.string,
  url: PropTypes.string,
  desktopImageUrl: PropTypes.string.isRequired,
  mobileImageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  lazyLoad: PropTypes.bool,
  alternateDesign: PropTypes.bool,
  onClick: PropTypes.func,
  analyticsMetadata: PropTypes.shape({
    correlationId: PropTypes.string,
    title: PropTypes.string,
    promotion: PropTypes.shape({
      creative: PropTypes.string,
    }),
  }),
}

SpotlightCard.defaultProps = {
  lazyLoad: true,
}

export default SpotlightCard
